/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const customSignupStyles = ({ colors, typography }: StylingContextState, hasDescription?: boolean) => {
  return {
    textWrapper: css`
      ${typography.text.small};
      line-height: 16px;
      text-align: left;
      color: ${colors.gray11};
      text-wrap: balance;

      @supports (text-wrap: pretty) {
        text-wrap: pretty;
      }
    `,
    standardTextWrapper: css`
      ${typography.text.small};
      color: ${colors.gray8};
      line-height: 1.5rem;
      text-align: left;
      padding-left: 0px;
      margin-left: 0px;
    `,
    iconsWrapper: css`
      font-size: 1rem;
      line-height: 2.1rem;
      font-weight: 600;
      color: ${colors.gray11};
      padding: 0.7rem 0;
      margin-right: 1rem;
      margin-bottom: 1.8rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    `,
    iconImg: css`
      img {
        min-width: 50px;
        max-width: 100%;
        height: 45px;
        object-fit: contain;
        margin-bottom: 12px;
      }
    `,
    dashboardImg: css`
      img {
        height: 200px;
        margin-left: -34px;
      }
    `,
    header: css`
      line-height: 28px;
      font-size: 24px;
      margin-top: 0;
      margin-bottom: ${hasDescription ? '8px' : '0'};
      color: ${colors.gray11};
      text-align: left;
      justify-content: unset;
      text-wrap: balance;

      @supports (text-wrap: pretty) {
        text-wrap: pretty;
      }
    `,
    description: css`
      font-size: 18px;
      font-weight: 400;
      line-height: 22px; /* 122.222% */
      letter-spacing: 0.045px;
      margin: 0;
      color: ${colors.gray11};
      text-align: left;
      text-wrap: balance;

      @supports (text-wrap: pretty) {
        text-wrap: pretty;
      }
    `,
    labelWrapper: css`
      ${typography.text.tiny};
      line-height: 1.2rem;
      font-weight: 500;
      color: ${colors.yellow};
      text-align: left;
      margin-bottom: 1rem;
      margin-left: 4.65rem;
    `,
    proContainer: css`
      margin-bottom: 2.5rem;
    `,
    proExtras: css`
      ${typography.text.small};
      color: ${colors.gray9};
      line-height: 2.5rem;
      text-align: left;
      margin-bottom: 1rem;
      margin-left: 4.65rem;
    `,
    freeForeverFeatures: css`
      list-style-type: none;
      ${typography.text.small};
      color: ${colors.gray9};
      line-height: 2.5rem;
      text-align: left;
    `,
    ulStyle: css`
      padding: 0px;
      margin-top: 0;
      font-size: 18px;
      font-weight: 400;
      display: flex;
      flex-flow: column nowrap;
      color: ${colors.gray11};

      @media (max-width: 768px) {
        font-size: 16px;
      }
    `,
    liStyle: css`
      list-style-type: none;
      line-height: 22px;
      display: flex;
      flex-flow: row nowrap;
      gap: 12px;
      margin: 8px 0;
    `,
    checkbox: css`
      width: 1em;
      height: 1em;
      object-fit: contain;
      position: relative;
      top: 0.125em;
    `,
    loader: css`
      color: blue;
      margin: 0 8px 0 0;
      padding: 0;
      text-align: center;
    `,
    li: css`
      font-size: 18px;
    `,
  };
};
